const initialState = {
  properties: {
    structure: {
      name: '',
      type: '',
      siret: '',
      address: {
        street: '',
        zipcode: '',
        city: '',
      },
      affiliation: [],
      label: '',
    },
    contacts: [{
      uid: 0,
      gender: '',
      firstname: '',
      lastname: '',
      position: '',
      zipcode: '',
      city: '',
      phone: '',
      email: '',
    }],
  },
};
export default initialState;



// WEBPACK FOOTER //
// ./src/modules/profile-initial.js